import { APICore } from "helpers/api/apiCore";
import config from "config";

const api = new APICore();

function createCustomerDumpReportApi(params: any) {
  let apiData: any = {
    customerExternalId: params.customerExternalId,
    saveReport: params.saveReport
  };

  let backendApiUrl = `${config.BACKEND_BASE_URL}/report/customer-dump-report`;

  return api.create(`${backendApiUrl}`, apiData);
}

export { createCustomerDumpReportApi };
